import { useEffect } from 'react';
import { getBranches } from '@/shared/reducers/branch.reducer';
import { getDepartments } from '@/shared/reducers/department.reducer';
import { getUsers } from '@/shared/reducers/user.reducer';
import { useAppDispatch, useAppSelector } from '@/store';
const CATALOG_PAGE = { page: 0, size: 1000, sort: 'id,asc' };
/** Load branches once when `enabled` (e.g. branch filter on Case Report). */
export function useBranchesCatalog(enabled = true) {
    const dispatch = useAppDispatch();
    const branches = useAppSelector((s) => s.branch.branches);
    const loading = useAppSelector((s) => s.branch.loading);
    useEffect(() => {
        if (!enabled || branches.length > 0)
            return;
        void dispatch(getBranches(CATALOG_PAGE));
    }, [dispatch, enabled, branches.length]);
    return { branches, loading };
}
/** Load CRM departments once when `enabled` (e.g. case registration / follow-up filters). */
export function useDepartmentsCatalog(enabled = true) {
    const dispatch = useAppDispatch();
    const departments = useAppSelector((s) => s.department.departments);
    const loading = useAppSelector((s) => s.department.loading);
    useEffect(() => {
        if (!enabled || departments.length > 0)
            return;
        void dispatch(getDepartments(CATALOG_PAGE));
    }, [dispatch, enabled, departments.length]);
    return { departments, loading };
}
/** Load IAM users once when `enabled` (e.g. agent pick-list on Cases Panel). */
export function useUsersCatalog(enabled = true) {
    const dispatch = useAppDispatch();
    const users = useAppSelector((s) => s.user.users);
    const loading = useAppSelector((s) => s.user.loading);
    useEffect(() => {
        if (!enabled || users.length > 0)
            return;
        void dispatch(getUsers(CATALOG_PAGE));
    }, [dispatch, enabled, users.length]);
    return { users, loading };
}
